import type { LeisureAreaParams, RegionAccommodationParams } from '@weberus/shared-types';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { QueryKeys } from './query-keys';

export const joyQueryKeys = createQueryKeys(QueryKeys.joy, {
  getRegionAccommodation: (params: RegionAccommodationParams) => ({
    queryKey: [{ params }],
  }),
  getLeisureAreaList: (params?: LeisureAreaParams) => ({
    queryKey: [{ params }],
  }),
});
